const onlineWarning = (state = false, action) => {
    switch(action.type) {
        case 'CONFIRM_ONLINE_WARNING':
            return true;
        default:
            return state;
    }
};

export default onlineWarning;


// WEBPACK FOOTER //
// ./src/reducers/onlineWarning.js